import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Paper from "@mui/material/Paper";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";

const listItemStyle = {
  margin: "1rem",
};

const About = () => {
  return (
    <Box minWidth='320px' maxWidth="1024px" m="0 auto" paddingTop={2}>
      <Stack spacing={2} textAlign="start">
        <Paper sx={{ padding: 2 }}>
          <Typography m={2} variant="h3">
            Our Mission
          </Typography>

          <Typography m={2} variant="body1" component='div'>
            We are a group of Japanese media enthusiasts who have come together
            in hopes of creating an experience for those interested in Japanese
            media. We specifically specialized in manga, but might expand
            depending on our members' interests and our community's interests.
            Our mission is tri-fold:
            <List>
              <ListItem>1. 
                To the best of our abiliy, provide translations that are
                accurate and represent the authors meaning and intentions and
                the Japanese meaning.
              </ListItem>
              <ListItem>2. 
                To translate material that is unlikely to receive a formal or
                fan translation for the following possible reasons:
              </ListItem>
              <List sx={{ paddingLeft: 4}}>
                  <ListItem>* 
                    The media does not fit within a typically successful genre
                    or topic demographic
                  </ListItem>
                  <ListItem>* 
                    The media has already been canceled/axed due to lack of
                    popularity, interest, or expected monetary gains
                  </ListItem>
                  <ListItem>* 
                    The media is not something we expect others to begin
                    translating (unless it gains popularity after the orignal
                    introduction whether formal or informal)
                  </ListItem>
                </List>  
              
              <ListItem>3. 
                To try to provide an experience of wonder, glee, and interest in
                the the Japanese culture and its media that was prevalent during
                the early 90's (this is particularly imporotant to our group,
                two of us grew up in a time when most of the world did not
                understand manga and anime and we waited days to months for fan
                translators to bring us the the latest translation in a time
                where ridicule for watching anime or reading manga was prevalnet
                and wide-spread)
              </ListItem>
            </List>
            {/* <ol>
            <li>
              To the best of our abiliy, provide translations that are accurate 
              and represent the authors meaning and intentions and the Japanese
              meaning.
            </li>
            <li>
              To translate material that is unlikely to receive a formal 
              or fan translation for the following possible reasons:
              <ul>
                <li>
                  The media does not fit within a typically successful genre
                  or topic demographic 
                </li>
                <li>
                  The media has already been canceled/axed due to lack of 
                  popularity, interest, or expected monetary gains
                </li>
                <li>
                  The media is not something we expect others to begin translating
                  (unless it gains popularity after the orignal introduction whether
                  formal or informal)
                </li>
              </ul>
            </li>
            <li>
              To try to provide an experience of wonder, glee, and interest in the 
              the Japanese culture and its media that was prevalent during the early
              90's (this is particularly imporotant to our group, two of us grew up
              in a time when most of the world did not understand manga and anime and
              we waited days to months for fan translators to bring us the the latest
              translation in a time where ridicule for watching anime or reading manga
              was prevalnet and wide-spread)
            </li>
          </ol> */}
          </Typography>
        </Paper>
        <Paper sx={{ padding: 2 }}>
          <Typography m={2} variant="h3">
            Boku-tachi
          </Typography>

          <Typography m={2} variant="body1">
            There are three founders of this group: Impe7us, Silica, and
            Silver-Torus.
          </Typography>

          <Typography m={2} variant="h5">
            Impe7us
          </Typography>

          <Typography m={2}>
            I am our leader and lead translator and ultimately the one who
            ensures that things get released. I started translating long ago as
            a way to learn and improve my Japanese. After translating manga for
            a while, I decided that it would be good to share my translations
            with the community.
          </Typography>
          <Typography m={2}>
            I am really excited for our first set of releases and would love to
            make this my new job if possible. I love translating Japanese media
            and would have more time to release if I could do this fulltime. If
            you want to support me on this journey, head over to the support
            page and check out our support options.
          </Typography>

          <Typography m={2} variant="h5">
            Silica
          </Typography>

          <Typography m={2}>
            I am the resident artist and redrawer and handle anyting that is
            graphic design related. I will also be typesetting. I am relatively
            new to manga and have only been reading manga for a year or two now,
            and while my foucs is on erotic manga, I have agreed to help out
            with redrawing anything in return for the occassional ero manga
            release (on our subdomain; currently in progress according to
            Silver-Torus)
          </Typography>

          <Typography m={2} variant="h5">
            Silver-Torus
          </Typography>

          <Typography m={2}>
            There's not much to say about what I do here. I am the resident
            program engineer and I built this site and and the server backend.
            My primary tasks are developing new features for my team and for the
            users of this site. I'm trying my best to get the site up and
            running for my friend, Impe7us, but since I have work, I can only
            make incremental changes. I enjoy philosophical media and Sci-Fi and
            will occasionally help with typesetting if needed and my schedule
            permits.
          </Typography>

          <Typography m={2}></Typography>
        </Paper>
      </Stack>
    </Box>
  );
};

export default About;
